"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendNodeAPIRequest = sendNodeAPIRequest;
var _utils = require("./utils");
var _error = require("./error");
function sendNodeAPIRequest(path, method, headers, body, encoding, timeout, withCredentials, tlsOptions) {
  return new Promise(function (resolve, reject) {
    var u = require('url').parse(path);
    var form = (0, _utils.isFormData)(body) && body;
    var https = u.protocol === 'https:';
    var options = {
      host: u.hostname,
      port: u.port || (https ? 443 : 80),
      path: (0, _utils.normalizeTrailingSlashInPath)(path, u) + (u.search || ''),
      method: method,
      headers: headers,
      timeout: timeout
    };
    if (typeof withCredentials === 'boolean') {
      options.withCredentials = withCredentials;
    }
    var withClientCert = !!(tlsOptions && (tlsOptions.cert || tlsOptions.key));
    if (tlsOptions) {
      if (!https) {
        // going ahead would silently drop the certificate and send the request in plain text,
        // there is no mutual TLS without TLS
        return reject(new _error.TLSError('A client certificate can only be used with an https:// URL.'));
      }
      Object.assign(options, tlsOptions);
    }

    // a TLS failure arrives here as an opaque socket/OpenSSL error, translate the ones we recognize
    var rejectWithError = function rejectWithError(error) {
      return reject((0, _error.toTLSError)(error, withClientCert) || error);
    };
    var _send = function _send() {
      var Buffer = require('buffer').Buffer;
      var httpClient = require(https ? 'https' : 'http');
      var req = httpClient.request(options, function (res) {
        var strings = [];
        var buffers = [];
        var bufferLength = 0;
        var body = '';
        var status = res.statusCode,
          statusText = res.statusMessage,
          headers = res.headers;
        res.on('data', function (chunk) {
          if (!Buffer.isBuffer(chunk)) {
            strings.push(chunk);
          } else if (chunk.length) {
            bufferLength += chunk.length;
            buffers.push(chunk);
          }
        });
        res.on('end', function () {
          if (bufferLength) {
            body = Buffer.concat(buffers, bufferLength);
            if (encoding != null) {
              body = body.toString(encoding);
            }
          } else if (strings.length) {
            body = strings.join();
          } else if (encoding == null) {
            // a raw request asked for bytes, and a 0 byte response is an empty buffer,
            // not the empty string the body is initialized with
            body = Buffer.alloc(0);
          }
          resolve({
            status: status,
            statusText: statusText,
            headers: headers,
            body: body
          });
        });
        res.on('error', rejectWithError);
      });
      req.on('error', rejectWithError);
      req.on('timeout', function () {
        req.destroy(new Error('Connection aborted due to timeout'));
      });
      if (body) {
        if ((0, _utils.isStream)(body)) {
          body.pipe(req);
          return;
        }
        req.write(body);
      }
      req.end();
    };

    // an unusable certificate/key/passphrase makes https.request() throw synchronously, and for a
    // form body _send() runs from a callback where a throw would escape the promise altogether
    var send = function send() {
      try {
        _send();
      } catch (error) {
        rejectWithError(error);
      }
    };
    if (form) {
      Object.assign(options.headers, form.getHeaders());
      form.getLength(function (err, length) {
        if (!err && !isNaN(length)) {
          options.headers['content-length'] = length;
        }
        send();
      });
    } else {
      if (body && !options.headers['content-length']) {
        var Buffer = require('buffer').Buffer;
        options.headers['content-length'] = Buffer.byteLength(body);
      }
      send();
    }
  });
}